module.exports = __webpack_public_path__ + "img/benefits-06.60869522.png";